<script setup lang="ts">
import { useSettingsStore } from '@/stores/settings'

const settings = useSettingsStore()

function toggle() {
  settings.setTheme(settings.resolvedTheme === 'dark' ? 'light' : 'dark')
}
</script>

<template>
  <button
    class="flex items-center justify-center w-7 h-7 rounded text-outline hover:text-on-surface hover:bg-surface-container-low transition-colors focus:outline-none"
    :aria-label="settings.resolvedTheme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'"
    @click="toggle"
  >
    <span class="material-symbols-outlined text-[18px]">
      {{ settings.resolvedTheme === 'dark' ? 'light_mode' : 'dark_mode' }}
    </span>
  </button>
</template>
